export const ROUTES = {
  HOME: "/home",
  PRODUCTS: "/products",
  PRODUCTS_PROPERTIES: "/products/product-properties",
  PRODUCTS_VALUE_SETS: "/products/value-sets",
  PRODUCTS_VALUE_SETS_CREATE: "/products/value-sets/create",
  PRODUCTS_VALUE_SETS_EDIT: (id: string) =>
    `/products/value-sets/${encodeURIComponent(id)}/edit`,
  PRODUCTS_VALUE_SETS_HISTORY: (id: string) =>
    `/products/value-sets/${encodeURIComponent(id)}/history`,
  PRODUCTS_VALUE_SETS_VIEW_VERSION: (id: string, version: string) =>
    `/products/value-sets/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  PRODUCTS_VALUE_SETS_DUPLICATE: (id: string) =>
    `/products/value-sets/${encodeURIComponent(id)}/duplicate`,
  FORMULAS_AND_FACTORS: "/formulasAndFactors",
  FORMULAS_AND_FACTORS_WIDTH_MATRIX: "/formulasAndFactors/widthMatrix",
  FORMULAS_AND_FACTORS_WIDTH_MATRIX_CREATE:
    "/formulasAndFactors/widthMatrix/create",
  FORMULAS_AND_FACTORS_WIDTH_MATRIX_EDIT: (id: string) =>
    `/formulasAndFactors/widthMatrix/${encodeURIComponent(id)}/edit`,
  FORMULAS_AND_FACTORS_WIDTH_MATRIX_HISTORY: (id: string) =>
    `/formulasAndFactors/widthMatrix/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_WIDTH_MATRIX_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/formulasAndFactors/widthMatrix/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  FORMULAS_AND_FACTORS_WIDTH_MATRIX_DUPLICATE: (id: string) =>
    `/formulasAndFactors/widthMatrix/${encodeURIComponent(id)}/duplicate`,
  FORMULAS_AND_FACTORS_LENGTH_MATRIX: "/formulasAndFactors/lengthMatrix",
  FORMULAS_AND_FACTORS_LENGTH_MATRIX_CREATE:
    "/formulasAndFactors/lengthMatrix/create",
  FORMULAS_AND_FACTORS_LENGTH_MATRIX_EDIT: (id: string) =>
    `/formulasAndFactors/lengthMatrix/${encodeURIComponent(id)}/edit`,
  FORMULAS_AND_FACTORS_LENGTH_MATRIX_HISTORY: (id: string) =>
    `/formulasAndFactors/lengthMatrix/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_LENGTH_MATRIX_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/formulasAndFactors/lengthMatrix/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  FORMULAS_AND_FACTORS_LENGTH_MATRIX_DUPLICATE: (id: string) =>
    `/formulasAndFactors/lengthMatrix/${encodeURIComponent(id)}/duplicate`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CORRECTION:
    "/formulasAndFactors/measurementCorrection",
  FORMULAS_AND_FACTORS_MEASUREMENT_CORRECTION_CREATE:
    "/formulasAndFactors/measurementCorrection/create",
  FORMULAS_AND_FACTORS_MEASUREMENT_CORRECTION_EDIT: (id: string) =>
    `/formulasAndFactors/measurementCorrection/${encodeURIComponent(id)}/edit`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CORRECTION_HISTORY: (id: string) =>
    `/formulasAndFactors/measurementCorrection/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CORRECTION_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/formulasAndFactors/measurementCorrection/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CORRECTION_DUPLICATE: (id: string) =>
    `/formulasAndFactors/measurementCorrection/${encodeURIComponent(id)}/duplicate`,
  FORMULAS_AND_FACTORS_KNITTING_SEQUENCE:
    "/formulasAndFactors/knittingSequence",
  FORMULAS_AND_FACTORS_KNITTING_SEQUENCE_CREATE:
    "/formulasAndFactors/knittingSequence/create",
  FORMULAS_AND_FACTORS_KNITTING_SEQUENCE_EDIT: (id: string) =>
    `/formulasAndFactors/knittingSequence/${encodeURIComponent(id)}/edit`,
  FORMULAS_AND_FACTORS_KNITTING_SEQUENCE_HISTORY: (id: string) =>
    `/formulasAndFactors/knittingSequence/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_KNITTING_SEQUENCE_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/formulasAndFactors/knittingSequence/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  FORMULAS_AND_FACTORS_KNITTING_SEQUENCE_DUPLICATE: (id: string) =>
    `/formulasAndFactors/knittingSequence/${encodeURIComponent(id)}/duplicate`,
  FORMULAS_AND_FACTORS_BASE_SIZE_CALCULATION_FORMULA:
    "/formulasAndFactors/baseSizeCalculationFormula",
  FORMULAS_AND_FACTORS_BASE_SIZE_CALCULATION_FORMULA_CREATE:
    "/formulasAndFactors/baseSizeCalculationFormula/create",
  FORMULAS_AND_FACTORS_BASE_SIZE_CALCULATION_FORMULA_EDIT: (id: string) =>
    `/formulasAndFactors/baseSizeCalculationFormula/${encodeURIComponent(id)}/edit`,
  FORMULAS_AND_FACTORS_BASE_SIZE_CALCULATION_FORMULA_HISTORY: (id: string) =>
    `/formulasAndFactors/baseSizeCalculationFormula/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_BASE_SIZE_CALCULATION_FORMULA_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/formulasAndFactors/baseSizeCalculationFormula/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  FORMULAS_AND_FACTORS_BASE_SIZE_CALCULATION_FORMULA_DUPLICATE: (id: string) =>
    `/formulasAndFactors/baseSizeCalculationFormula/${encodeURIComponent(id)}/duplicate`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FACTOR:
    "/formulasAndFactors/measurementCalculationFactor",
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FACTOR_CREATE:
    "/formulasAndFactors/measurementCalculationFactor/create",
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FACTOR_EDIT: (id: string) =>
    `/formulasAndFactors/measurementCalculationFactor/${encodeURIComponent(id)}/edit`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FACTOR_HISTORY: (id: string) =>
    `/formulasAndFactors/measurementCalculationFactor/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FACTOR_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/formulasAndFactors/measurementCalculationFactor/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FACTOR_DUPLICATE: (id: string) =>
    `/formulasAndFactors/measurementCalculationFactor/${encodeURIComponent(id)}/duplicate`,
  MACHINES: "/machines",
  MACHINES_MACHINE_ASSIGNMENT: "/machines/machineAssignment",
  MACHINES_MACHINE_ASSIGNMENT_CREATE: "/machines/machineAssignment/create",
  MACHINES_MACHINE_ASSIGNMENT_EDIT: (id: string) =>
    `/machines/machineAssignment/${encodeURIComponent(id)}/edit`,
  MACHINES_MACHINE_ASSIGNMENT_HISTORY: (id: string) =>
    `/machines/machineAssignment/${encodeURIComponent(id)}/history`,
  MACHINES_MACHINE_ASSIGNMENT_VIEW_VERSION: (id: string, version: string) =>
    `/machines/machineAssignment/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  MACHINES_MACHINE_ASSIGNMENT_DUPLICATE: (id: string) =>
    `/machines/machineAssignment/${encodeURIComponent(id)}/duplicate`,
  CHECK_DIMENSIONS: "/checkDimensions",
  CHECK_DIMENSIONS_WIDTH_CHECK_DIMENSION:
    "/checkDimensions/widthCheckDimension",
  CHECK_DIMENSIONS_WIDTH_CHECK_DIMENSION_CREATE:
    "/checkDimensions/widthCheckDimension/create",
  CHECK_DIMENSIONS_WIDTH_CHECK_DIMENSION_EDIT: (id: string) =>
    `/checkDimensions/widthCheckDimension/${encodeURIComponent(id)}/edit`,
  CHECK_DIMENSIONS_WIDTH_CHECK_DIMENSION_DUPLICATE: (id: string) =>
    `/checkDimensions/widthCheckDimension/${encodeURIComponent(id)}/duplicate`,
  ASSETS: "/assets",
  ASSETS_KNITTING_PROGRAM_LIBRARY: "/assets/knittingProgramLibrary",
  ASSETS_KNITTING_PROGRAM_LIBRARY_CREATE:
    "/assets/knittingProgramLibrary/create",
  ASSETS_KNITTING_PROGRAM_LIBRARY_EDIT: (id: string) =>
    `/assets/knittingProgramLibrary/${encodeURIComponent(id)}/edit`,
  ASSETS_KNITTING_PROGRAM_LIBRARY_UPLOAD: (id: string) =>
    `/assets/knittingProgramLibrary/${encodeURIComponent(id)}/upload`,
  ASSETS_KNITTING_PROGRAM_LIBRARY_HISTORY: (id: string) =>
    `/assets/knittingProgramLibrary/${encodeURIComponent(id)}/history`,
  ASSETS_KNITTING_PROGRAM_HISTORY: (programId: string) =>
    `/assets/knittingProgramLibrary/programs/${encodeURIComponent(programId)}/history`,
  ASSETS_PATTERN_PROGRAMS: "/assets/patternPrograms",
  ASSETS_PATTERN_PROGRAMS_CREATE: "/assets/patternPrograms/create",
  ASSETS_PATTERN_PROGRAMS_EDIT: (id: string) =>
    `/assets/patternPrograms/${encodeURIComponent(id)}/edit`,
  ASSETS_PATTERN_PROGRAMS_HISTORY: (id: string) =>
    `/assets/patternPrograms/${encodeURIComponent(id)}/history`,
  ASSETS_MINI_PROGRAMS: "/assets/miniPrograms",
  ASSETS_MINI_PROGRAMS_CREATE: "/assets/miniPrograms/create",
  ASSETS_MINI_PROGRAMS_EDIT: (id: string) =>
    `/assets/miniPrograms/${encodeURIComponent(id)}/edit`,
  ASSETS_MINI_PROGRAMS_HISTORY: (id: string) =>
    `/assets/miniPrograms/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FORMULA:
    "/formulasAndFactors/measurementCalculationFormula",
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FORMULA_CREATE:
    "/formulasAndFactors/measurementCalculationFormula/create",
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FORMULA_EDIT: (id: string) =>
    `/formulasAndFactors/measurementCalculationFormula/${encodeURIComponent(id)}/edit`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FORMULA_HISTORY: (id: string) =>
    `/formulasAndFactors/measurementCalculationFormula/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FORMULA_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/formulasAndFactors/measurementCalculationFormula/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FORMULA_DUPLICATE: (
    id: string,
  ) =>
    `/formulasAndFactors/measurementCalculationFormula/${encodeURIComponent(id)}/duplicate`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FORMULA_DELETE: (id: string) =>
    `/formulasAndFactors/measurementCalculationFormula/${encodeURIComponent(id)}/delete`,
} as const;
